import { render, staticRenderFns } from "./mix_ratios.vue?vue&type=template&id=3828ff15&"
import script from "./mix_ratios.vue?vue&type=script&lang=js&"
export * from "./mix_ratios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports